var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D21034",
    d: "M41.74 0H6.24C2.797 0 0 2.797 0 6.239v35.522C0 45.203 2.797 48 6.239 48h35.522C45.203 48 48 45.203 48 41.761V6.239C47.98 2.797 45.182 0 41.74 0z",
    transform: "translate(-18 -106) translate(0 94) translate(18 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.59 23.959c0 1.414-.538 2.709-1.415 3.705l1.853 1.613c1.255-1.414 2.012-3.266 2.012-5.298 0-2.012-.737-3.845-1.972-5.26l-1.853 1.614c.857.956 1.374 2.231 1.374 3.626zM18.414 23.959c0-1.395.518-2.65 1.355-3.626l-1.853-1.593c-1.215 1.394-1.952 3.227-1.952 5.219 0 2.012.757 3.864 1.972 5.279l1.853-1.614c-.857-.976-1.375-2.25-1.375-3.665zM35.167 23.959c0 2.828-1.056 5.398-2.769 7.37l1.972 1.713c2.132-2.43 3.427-5.597 3.427-9.083 0-3.466-1.275-6.614-3.387-9.044l-1.972 1.713c1.693 1.972 2.73 4.542 2.73 7.33zM12.817 23.959c0-2.79 1.015-5.339 2.709-7.291l-1.952-1.713c-2.092 2.41-3.367 5.577-3.367 9.004 0 3.466 1.275 6.633 3.406 9.044l1.972-1.714c-1.713-1.952-2.768-4.521-2.768-7.33z",
    transform: "translate(-18 -106) translate(0 94) translate(18 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.753 11.15l-2.092 1.833c2.57 2.948 4.104 6.792 4.104 10.996 0 4.223-1.574 8.087-4.144 11.036l2.092 1.832c3.008-3.446 4.84-7.928 4.84-12.848 0-4.94-1.812-9.423-4.8-12.849zM11.362 34.975c-2.57-2.949-4.123-6.793-4.123-11.016 0-4.203 1.554-8.028 4.084-10.956L9.23 11.17C6.263 14.596 4.45 19.078 4.45 23.959c0 4.9 1.813 9.402 4.82 12.828l2.092-1.812z",
    transform: "translate(-18 -106) translate(0 94) translate(18 12)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b2b0154c6c73c370f83eff1aa3f47cc1.svg";
export { ForwardRef as ReactComponent };